import { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { filterByDate, filterByDistance } from 'tennders-stracture/libs/map'
import { apiPost } from 'tennders-stracture/libs/api'
import { REDUX_PROMPT_TYPES } from 'tennders-common/stores/prompt/action'
import useTransaction from 'tennders-transactions/hooks/useTransaction'

const useAssignLoads = () => {
  const dispatch = useDispatch()
  const [range, setrange] = useState(5000)
  const [dateRange, setdateRange] = useState(-1)
  const [loads, setloads] = useState([])
  const [loading, setloading] = useState(false)
  const [allItems, setallItems] = useState([])
  const { transaction } = useTransaction()

  const assignLoad = (transaction) => dispatch({
    type: REDUX_PROMPT_TYPES.ASSIGN_LOADS,
    payload: transaction
  })

  const filter = useCallback((unfilteredItems) => {
    let items = filterByDistance(transaction?.pickupRoute?.location, [...unfilteredItems], range)
    if (dateRange !== false && `${dateRange}` !== '-1' && dateRange !== 'all') {
      items = filterByDate(transaction?.dayDiff, [...items])
    }
    setloads(items)
  }, [transaction?.pickupRoute?.location, transaction?.dayDiff, range, dateRange])

  const fetchLoads = async (transactionId) => {
    setloading(true)
    const response = await apiPost('loads/to-assign', { transaction: transactionId })
    if (response?.items) {
      setallItems(response?.items)
      filter([...response?.items], range)
    }
    setloading(false)
  }

  useEffect(() => {
    filter(allItems)
  }, [allItems, range, dateRange, transaction?.pickupRoute?.location])

  useEffect(() => {
    fetchLoads(transaction?.id)
  }, [transaction?.id])

  return {
    loading,
    range,
    setrange,
    dateRange,
    setdateRange,
    fetchLoads,
    loads,
    assignLoad,
    loadToAssign: transaction
  }
}

export default useAssignLoads
